import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as Constants from '../../../helpers/Constants'
import * as Functions from '../../../helpers/Functions'
import Styles from './styles'

class CalendarDots extends Component {
  renderDot(time) {
    const location = window.location.pathname
    const { date, data } = this.props
    const today = new Date()
    let style = Styles.dot
    const parsedDate = Functions.parseDate(date)
    if (this.props.focused || location !== '/laundryBookings') return null
    const bookings = time.bookings.filter(b => b.date === parsedDate)
    const passed = Functions.laundryTimePassed(date, time.endTime)
    let bookedByMe = false
    bookings.forEach(b => {
      if (b.apartment && b.apartment.id === data.apartment.id) {
        bookedByMe = true
      }
    })

    if (passed) {
      style = {
        ...style,
        backgroundColor: Constants.WHITE_LABEL.colors.warning
      }
    } else if (bookedByMe) {
      style = {
        ...style,
        backgroundColor: Constants.WHITE_LABEL.colors.calendar.header
      }
    } else if (bookings.length === data.laundries.length) {
      style = {
        ...style,
        backgroundColor: Constants.WHITE_LABEL.colors.warning
      }
    } else {
      style = {
        ...style,
        backgroundColor: Constants.WHITE_LABEL.colors.primary
      }
    }

    return <div style={style} />
  }

  renderFourDots(i, times) {
    const dots = []

    for (let j = i; j < i + 4; j++) {
      if (j < times.length) {
        dots.push(this.renderDot(times[j]))
      } else {
        dots.push(<div key={j} style={Styles.dot} />)
      }
    }

    return dots
  }

  renderDots() {
    const { data, date } = this.props
    const times = Functions.getAndSortTodaysLaundryTimes(
      data.laundryTimes,
      date
    )

    const dots = []

    for (let i = 0; i < times.length; i += 4) {
      dots.push(
        <div style={Styles.dotContainer} key={i}>
          {this.renderFourDots(i, times)}
        </div>
      )
    }

    return dots
  }

  render() {
    return <div style={Styles.container}>{this.renderDots()}</div>
  }
}

const mapStateToProps = ({ user, data, config, laundryBooking }) => {
  const { language } = config
  return { user, data, language, laundryBooking }
}

export default connect(
  mapStateToProps,
  null
)(CalendarDots)



// WEBPACK FOOTER //
// ./src/components/containers/CalendarDots/index.js